export const colors = {
  titleColor: '#ffffff',
  subtitleColor: '#9f9f9f'
};
